// Notifications view translations for all 11 supported languages

export const notificationsTranslations = {
  pt: {
    title: "Notificações",
    subtitle: "Mantém-te atualizado com as tuas atividades financeiras",
    mark_all_read: "Marcar tudo como lido",
    tabs: {
      all: "Todas",
      unread: "Não lidas",
      alerts: "Alertas",
      payments: "Pagamentos",
      updates: "Atualizações",
    },
    empty: {
      title: "Sem notificações",
      unread: "Já está tudo em dia! Nenhuma notificação por ler.",
      category: "Ainda não tens notificações nesta categoria.",
    },
    actions: {
      mark_read: "Marcar como lida",
      delete: "Eliminar",
    },
    items: {
      item_1: {
        title: "Alerta de orçamento",
        message: "O orçamento de marketing excedeu 15%. Despesa atual: €11.500 / €10.000",
        time: "há 5 minutos",
      },
      item_2: {
        title: "Pagamento recebido",
        message: "O cliente ABC pagou a fatura #INV-2024-001 no valor de €2.500",
        time: "há 1 hora",
      },
      item_3: {
        title: "Atualização de fluxo de caixa",
        message: "O teu relatório mensal de fluxo de caixa de dezembro de 2024 está pronto para ver",
        time: "há 3 horas",
      },
      item_4: {
        title: "Banco conectado",
        message: "Conta Santander sincronizada com sucesso. 127 novas transações importadas",
        time: "há 1 dia",
      },
      item_5: {
        title: "Aviso de saldo baixo",
        message: "O saldo da tua conta operacional está abaixo de €5.000. Saldo atual: €4.250",
        time: "há 1 dia",
      },
      item_6: {
        title: "Pagamento pendente",
        message: "A fatura #INV-2024-002 ao fornecedor XYZ (€1.200) vence em 3 dias",
        time: "há 2 dias",
      },
      item_7: {
        title: "Pagamento enviado",
        message: "Pagamento de salários de €35.000 processado com sucesso para 5 membros da equipa",
        time: "há 3 dias",
      },
      item_8: {
        title: "Relatório gerado",
        message: "O Relatório Financeiro do 4.º trimestre de 2024 está pronto. Veja insights e tendências detalhadas",
        time: "há 5 dias",
      },
      item_9: {
        title: "Transação incomum",
        message: "Transação elevada detetada: €8.500 para fornecedor desconhecido. Revisão necessária",
        time: "há 1 semana",
      },
      item_10: {
        title: "Pagamento recorrente",
        message: "Subscrição mensal do Figma renovada: €45",
        time: "há 1 semana",
      },
    },
  },
  en: {
    title: "Notifications",
    subtitle: "Stay updated with your financial activities",
    mark_all_read: "Mark all read",
    tabs: {
      all: "All",
      unread: "Unread",
      alerts: "Alerts",
      payments: "Payments",
      updates: "Updates",
    },
    empty: {
      title: "No notifications",
      unread: "You're all caught up! No unread notifications.",
      category: "You don't have any notifications in this category yet.",
    },
    actions: {
      mark_read: "Mark as read",
      delete: "Delete",
    },
    items: {
      item_1: {
        title: "Budget Alert",
        message: "Marketing budget exceeded by 15%. Current spend: €11,500 / €10,000",
        time: "5 minutes ago",
      },
      item_2: {
        title: "Payment Received",
        message: "Client ABC paid invoice #INV-2024-001 for €2,500",
        time: "1 hour ago",
      },
      item_3: {
        title: "Cashflow Update",
        message: "Your monthly cashflow report for December 2024 is ready to view",
        time: "3 hours ago",
      },
      item_4: {
        title: "Bank Connected",
        message: "Santander account synced successfully. 127 new transactions imported",
        time: "1 day ago",
      },
      item_5: {
        title: "Low Balance Warning",
        message: "Your operating account balance is below €5,000. Current balance: €4,250",
        time: "1 day ago",
      },
      item_6: {
        title: "Payment Pending",
        message: "Invoice #INV-2024-002 to Vendor XYZ (€1,200) is due in 3 days",
        time: "2 days ago",
      },
      item_7: {
        title: "Payment Sent",
        message: "Salary payment of €35,000 processed successfully to 5 team members",
        time: "3 days ago",
      },
      item_8: {
        title: "Report Generated",
        message: "Q4 2024 Financial Report is ready. View detailed insights and trends",
        time: "5 days ago",
      },
      item_9: {
        title: "Unusual Transaction",
        message: "Large transaction detected: €8,500 to unknown vendor. Review required",
        time: "1 week ago",
      },
      item_10: {
        title: "Recurring Payment",
        message: "Monthly subscription to Figma renewed: €45",
        time: "1 week ago",
      },
    },
  },
  es: {
    title: "Notificaciones",
    subtitle: "Mantente al día con tus actividades financieras",
    mark_all_read: "Marcar todo como leído",
    tabs: {
      all: "Todas",
      unread: "No leídas",
      alerts: "Alertas",
      payments: "Pagos",
      updates: "Actualizaciones",
    },
    empty: {
      title: "Sin notificaciones",
      unread: "¡Estás al día! No hay notificaciones sin leer.",
      category: "Todavía no tienes notificaciones en esta categoría.",
    },
    actions: {
      mark_read: "Marcar como leída",
      delete: "Eliminar",
    },
    items: {
      item_1: {
        title: "Alerta de presupuesto",
        message: "El presupuesto de marketing superó un 15%. Gasto actual: €11.500 / €10.000",
        time: "hace 5 minutos",
      },
      item_2: {
        title: "Pago recibido",
        message: "El cliente ABC pagó la factura #INV-2024-001 por €2.500",
        time: "hace 1 hora",
      },
      item_3: {
        title: "Actualización de flujo de caja",
        message: "Tu informe mensual de flujo de caja de diciembre de 2024 está listo para ver",
        time: "hace 3 horas",
      },
      item_4: {
        title: "Banco conectado",
        message: "Cuenta Santander sincronizada con éxito. 127 nuevas transacciones importadas",
        time: "hace 1 día",
      },
      item_5: {
        title: "Aviso de saldo bajo",
        message: "El saldo de tu cuenta operativa está por debajo de €5.000. Saldo actual: €4.250",
        time: "hace 1 día",
      },
      item_6: {
        title: "Pago pendiente",
        message: "La factura #INV-2024-002 a Proveedor XYZ (€1.200) vence en 3 días",
        time: "hace 2 días",
      },
      item_7: {
        title: "Pago enviado",
        message: "Pago de salarios de €35.000 procesado con éxito a 5 miembros del equipo",
        time: "hace 3 días",
      },
      item_8: {
        title: "Informe generado",
        message: "El Informe Financiero del Q4 2024 está listo. Consulta insights y tendencias detalladas",
        time: "hace 5 días",
      },
      item_9: {
        title: "Transacción inusual",
        message: "Transacción grande detectada: €8.500 a proveedor desconocido. Revisión requerida",
        time: "hace 1 semana",
      },
      item_10: {
        title: "Pago recurrente",
        message: "Suscripción mensual a Figma renovada: €45",
        time: "hace 1 semana",
      },
    },
  },
  et: {
    title: "Teavitused",
    subtitle: "Püsi kursis oma finantstegevustega",
    mark_all_read: "Märgi kõik loetuks",
    tabs: {
      all: "Kõik",
      unread: "Lugemata",
      alerts: "Hoiatused",
      payments: "Maksed",
      updates: "Uuendused",
    },
    empty: {
      title: "Teavitusi pole",
      unread: "Kõik on korras! Lugemata teavitusi pole.",
      category: "Selles kategoorias pole veel teavitusi.",
    },
    actions: {
      mark_read: "Märgi loetuks",
      delete: "Kustuta",
    },
    items: {
      item_1: {
        title: "Eelarve hoiatus",
        message: "Turunduseelarve ületas 15%. Praegune kulu: €11.500 / €10.000",
        time: "5 minutit tagasi",
      },
      item_2: {
        title: "Makse laekunud",
        message: "Klient ABC tasus arve #INV-2024-001 summas €2.500",
        time: "1 tund tagasi",
      },
      item_3: {
        title: "Rahavoo värskendus",
        message: "Sinu detsembri 2024 kuine rahavoo aruanne on vaatamiseks valmis",
        time: "3 tundi tagasi",
      },
      item_4: {
        title: "Pank ühendatud",
        message: "Santanderi konto sünkroniseeriti edukalt. 127 uut tehingut imporditud",
        time: "1 päev tagasi",
      },
      item_5: {
        title: "Madala saldo hoiatus",
        message: "Sinu töökorralduskonto saldo on alla €5.000. Praegune saldo: €4.250",
        time: "1 päev tagasi",
      },
      item_6: {
        title: "Makse ootel",
        message: "Arve #INV-2024-002 tarnijale XYZ (€1.200) tuleb tasuda 3 päeva pärast",
        time: "2 päeva tagasi",
      },
      item_7: {
        title: "Makse saadetud",
        message: "€35.000 palgamakse töödeldi edukalt 5 meeskonnaliikmele",
        time: "3 päeva tagasi",
      },
      item_8: {
        title: "Aruanne genereeritud",
        message: "2024. aasta IV kvartali finantsaruanne on valmis. Vaata detailseid ülevaateid ja trende",
        time: "5 päeva tagasi",
      },
      item_9: {
        title: "Ebatavaline tehing",
        message: "Tuvastati suur tehing: €8.500 tundmatule tarnijale. Vajalik ülevaatus",
        time: "1 nädal tagasi",
      },
      item_10: {
        title: "Korduv makse",
        message: "Figma kuutellimus uuendatud: €45",
        time: "1 nädal tagasi",
      },
    },
  },
  de: {
    title: "Benachrichtigungen",
    subtitle: "Bleib über deine finanziellen Aktivitäten auf dem Laufenden",
    mark_all_read: "Alle als gelesen markieren",
    tabs: {
      all: "Alle",
      unread: "Ungelesen",
      alerts: "Warnungen",
      payments: "Zahlungen",
      updates: "Updates",
    },
    empty: {
      title: "Keine Benachrichtigungen",
      unread: "Alles erledigt! Keine ungelesenen Benachrichtigungen.",
      category: "In dieser Kategorie gibt es noch keine Benachrichtigungen.",
    },
    actions: {
      mark_read: "Als gelesen markieren",
      delete: "Löschen",
    },
    items: {
      item_1: {
        title: "Budgetwarnung",
        message: "Das Marketingbudget wurde um 15 % überschritten. Aktuelle Ausgaben: €11.500 / €10.000",
        time: "vor 5 Minuten",
      },
      item_2: {
        title: "Zahlung erhalten",
        message: "Kunde ABC hat die Rechnung #INV-2024-001 über €2.500 bezahlt",
        time: "vor 1 Stunde",
      },
      item_3: {
        title: "Cashflow-Update",
        message: "Dein monatlicher Cashflow-Bericht für Dezember 2024 ist verfügbar",
        time: "vor 3 Stunden",
      },
      item_4: {
        title: "Bank verbunden",
        message: "Santander-Konto erfolgreich synchronisiert. 127 neue Transaktionen importiert",
        time: "vor 1 Tag",
      },
      item_5: {
        title: "Warnung bei niedrigem Kontostand",
        message: "Der Kontostand deines Betriebskontos liegt unter €5.000. Aktueller Saldo: €4.250",
        time: "vor 1 Tag",
      },
      item_6: {
        title: "Zahlung ausstehend",
        message: "Rechnung #INV-2024-002 an Lieferant XYZ (€1.200) ist in 3 Tagen fällig",
        time: "vor 2 Tagen",
      },
      item_7: {
        title: "Zahlung gesendet",
        message: "Gehaltszahlung von €35.000 erfolgreich an 5 Teammitglieder verarbeitet",
        time: "vor 3 Tagen",
      },
      item_8: {
        title: "Bericht erstellt",
        message: "Der Finanzbericht Q4 2024 ist bereit. Detaillierte Einblicke und Trends ansehen",
        time: "vor 5 Tagen",
      },
      item_9: {
        title: "Ungewöhnliche Transaktion",
        message: "Große Transaktion erkannt: €8.500 an unbekannten Lieferanten. Prüfung erforderlich",
        time: "vor 1 Woche",
      },
      item_10: {
        title: "Wiederkehrende Zahlung",
        message: "Monatliches Figma-Abonnement erneuert: €45",
        time: "vor 1 Woche",
      },
    },
  },
  fr: {
    title: "Notifications",
    subtitle: "Restez informé de vos activités financières",
    mark_all_read: "Tout marquer comme lu",
    tabs: {
      all: "Toutes",
      unread: "Non lues",
      alerts: "Alertes",
      payments: "Paiements",
      updates: "Mises à jour",
    },
    empty: {
      title: "Aucune notification",
      unread: "Tout est à jour ! Aucune notification non lue.",
      category: "Vous n'avez pas encore de notifications dans cette catégorie.",
    },
    actions: {
      mark_read: "Marquer comme lu",
      delete: "Supprimer",
    },
    items: {
      item_1: {
        title: "Alerte budget",
        message: "Le budget marketing a dépassé de 15 %. Dépense actuelle : €11 500 / €10 000",
        time: "il y a 5 minutes",
      },
      item_2: {
        title: "Paiement reçu",
        message: "Le client ABC a payé la facture #INV-2024-001 pour €2 500",
        time: "il y a 1 heure",
      },
      item_3: {
        title: "Mise à jour du flux de trésorerie",
        message: "Votre rapport mensuel de flux de trésorerie pour décembre 2024 est prêt",
        time: "il y a 3 heures",
      },
      item_4: {
        title: "Banque connectée",
        message: "Compte Santander synchronisé avec succès. 127 nouvelles transactions importées",
        time: "il y a 1 jour",
      },
      item_5: {
        title: "Alerte de solde faible",
        message: "Le solde de votre compte opérationnel est inférieur à €5 000. Solde actuel : €4 250",
        time: "il y a 1 jour",
      },
      item_6: {
        title: "Paiement en attente",
        message: "La facture #INV-2024-002 au fournisseur XYZ (€1 200) arrive à échéance dans 3 jours",
        time: "il y a 2 jours",
      },
      item_7: {
        title: "Paiement envoyé",
        message: "Paiement des salaires de €35 000 traité avec succès pour 5 membres de l'équipe",
        time: "il y a 3 jours",
      },
      item_8: {
        title: "Rapport généré",
        message: "Le rapport financier T4 2024 est prêt. Consultez les insights et tendances détaillés",
        time: "il y a 5 jours",
      },
      item_9: {
        title: "Transaction inhabituelle",
        message: "Transaction importante détectée : €8 500 vers un fournisseur inconnu. Examen requis",
        time: "il y a 1 semaine",
      },
      item_10: {
        title: "Paiement récurrent",
        message: "Abonnement mensuel à Figma renouvelé : €45",
        time: "il y a 1 semaine",
      },
    },
  },
  it: {
    title: "Notifiche",
    subtitle: "Rimani aggiornato sulle tue attività finanziarie",
    mark_all_read: "Segna tutte come lette",
    tabs: {
      all: "Tutte",
      unread: "Non lette",
      alerts: "Avvisi",
      payments: "Pagamenti",
      updates: "Aggiornamenti",
    },
    empty: {
      title: "Nessuna notifica",
      unread: "Sei aggiornato! Nessuna notifica non letta.",
      category: "Non hai ancora notifiche in questa categoria.",
    },
    actions: {
      mark_read: "Segna come letta",
      delete: "Elimina",
    },
    items: {
      item_1: {
        title: "Avviso di budget",
        message: "Il budget marketing ha superato il 15%. Spesa attuale: €11.500 / €10.000",
        time: "5 minuti fa",
      },
      item_2: {
        title: "Pagamento ricevuto",
        message: "Il cliente ABC ha pagato la fattura #INV-2024-001 per €2.500",
        time: "1 ora fa",
      },
      item_3: {
        title: "Aggiornamento del flusso di cassa",
        message: "Il tuo report mensile del flusso di cassa di dicembre 2024 è pronto",
        time: "3 ore fa",
      },
      item_4: {
        title: "Banca collegata",
        message: "Conto Santander sincronizzato con successo. 127 nuove transazioni importate",
        time: "1 giorno fa",
      },
      item_5: {
        title: "Avviso saldo basso",
        message: "Il saldo del tuo conto operativo è sotto €5.000. Saldo attuale: €4.250",
        time: "1 giorno fa",
      },
      item_6: {
        title: "Pagamento in sospeso",
        message: "La fattura #INV-2024-002 al fornitore XYZ (€1.200) scade tra 3 giorni",
        time: "2 giorni fa",
      },
      item_7: {
        title: "Pagamento inviato",
        message: "Pagamento stipendi di €35.000 elaborato con successo per 5 membri del team",
        time: "3 giorni fa",
      },
      item_8: {
        title: "Report generato",
        message: "Il Report Finanziario Q4 2024 è pronto. Consulta insight e trend dettagliati",
        time: "5 giorni fa",
      },
      item_9: {
        title: "Transazione insolita",
        message: "Rilevata transazione elevata: €8.500 verso fornitore sconosciuto. Revisione richiesta",
        time: "1 settimana fa",
      },
      item_10: {
        title: "Pagamento ricorrente",
        message: "Abbonamento mensile a Figma rinnovato: €45",
        time: "1 settimana fa",
      },
    },
  },
  nl: {
    title: "Meldingen",
    subtitle: "Blijf op de hoogte van je financiële activiteiten",
    mark_all_read: "Alles markeren als gelezen",
    tabs: {
      all: "Alle",
      unread: "Ongelezen",
      alerts: "Waarschuwingen",
      payments: "Betalingen",
      updates: "Updates",
    },
    empty: {
      title: "Geen meldingen",
      unread: "Je bent helemaal bij! Geen ongelezen meldingen.",
      category: "Je hebt nog geen meldingen in deze categorie.",
    },
    actions: {
      mark_read: "Markeren als gelezen",
      delete: "Verwijderen",
    },
    items: {
      item_1: {
        title: "Budgetwaarschuwing",
        message: "Het marketingbudget is met 15% overschreden. Huidige uitgaven: €11.500 / €10.000",
        time: "5 minuten geleden",
      },
      item_2: {
        title: "Betaling ontvangen",
        message: "Klant ABC heeft factuur #INV-2024-001 betaald voor €2.500",
        time: "1 uur geleden",
      },
      item_3: {
        title: "Cashflow-update",
        message: "Je maandelijkse cashflowrapport voor december 2024 staat klaar",
        time: "3 uur geleden",
      },
      item_4: {
        title: "Bank gekoppeld",
        message: "Santander-account succesvol gesynchroniseerd. 127 nieuwe transacties geïmporteerd",
        time: "1 dag geleden",
      },
      item_5: {
        title: "Waarschuwing laag saldo",
        message: "Het saldo van je operationele rekening is lager dan €5.000. Huidig saldo: €4.250",
        time: "1 dag geleden",
      },
      item_6: {
        title: "Betaling in afwachting",
        message: "Factuur #INV-2024-002 aan leverancier XYZ (€1.200) vervalt over 3 dagen",
        time: "2 dagen geleden",
      },
      item_7: {
        title: "Betaling verzonden",
        message: "Salarisbetaling van €35.000 succesvol verwerkt naar 5 teamleden",
        time: "3 dagen geleden",
      },
      item_8: {
        title: "Rapport gegenereerd",
        message: "Het financieel rapport Q4 2024 is klaar. Bekijk gedetailleerde inzichten en trends",
        time: "5 dagen geleden",
      },
      item_9: {
        title: "Ongebruikelijke transactie",
        message: "Grote transactie gedetecteerd: €8.500 naar onbekende leverancier. Beoordeling vereist",
        time: "1 week geleden",
      },
      item_10: {
        title: "Terugkerende betaling",
        message: "Maandelijkse Figma-abonnement verlengd: €45",
        time: "1 week geleden",
      },
    },
  },
  sv: {
    title: "Notiser",
    subtitle: "Håll dig uppdaterad om dina finansiella aktiviteter",
    mark_all_read: "Markera alla som lästa",
    tabs: {
      all: "Alla",
      unread: "Olästa",
      alerts: "Varningar",
      payments: "Betalningar",
      updates: "Uppdateringar",
    },
    empty: {
      title: "Inga notiser",
      unread: "Du är helt uppdaterad! Inga olästa notiser.",
      category: "Du har inga notiser i den här kategorin ännu.",
    },
    actions: {
      mark_read: "Markera som läst",
      delete: "Ta bort",
    },
    items: {
      item_1: {
        title: "Budgetvarning",
        message: "Marknadsföringsbudgeten överskreds med 15 %. Nuvarande kostnad: €11.500 / €10.000",
        time: "för 5 minuter sedan",
      },
      item_2: {
        title: "Betalning mottagen",
        message: "Kund ABC betalade faktura #INV-2024-001 på €2.500",
        time: "för 1 timme sedan",
      },
      item_3: {
        title: "Kassaflödesuppdatering",
        message: "Din månadsrapport för kassaflöde för december 2024 är klar att visa",
        time: "för 3 timmar sedan",
      },
      item_4: {
        title: "Bank ansluten",
        message: "Santander-konto synkroniserat. 127 nya transaktioner importerade",
        time: "för 1 dag sedan",
      },
      item_5: {
        title: "Varning för lågt saldo",
        message: "Saldo på ditt driftskonto är under €5.000. Aktuellt saldo: €4.250",
        time: "för 1 dag sedan",
      },
      item_6: {
        title: "Betalning väntar",
        message: "Faktura #INV-2024-002 till leverantör XYZ (€1.200) förfaller om 3 dagar",
        time: "för 2 dagar sedan",
      },
      item_7: {
        title: "Betalning skickad",
        message: "Lönebetalning på €35.000 behandlad till 5 teammedlemmar",
        time: "för 3 dagar sedan",
      },
      item_8: {
        title: "Rapport genererad",
        message: "Finansiell rapport för Q4 2024 är klar. Se detaljerade insikter och trender",
        time: "för 5 dagar sedan",
      },
      item_9: {
        title: "Ovanlig transaktion",
        message: "Stor transaktion upptäckt: €8.500 till okänd leverantör. Granskning krävs",
        time: "för 1 vecka sedan",
      },
      item_10: {
        title: "Återkommande betalning",
        message: "Månadsabonnemang på Figma förnyat: €45",
        time: "för 1 vecka sedan",
      },
    },
  },
  da: {
    title: "Notifikationer",
    subtitle: "Hold dig opdateret om dine finansielle aktiviteter",
    mark_all_read: "Markér alle som læst",
    tabs: {
      all: "Alle",
      unread: "Ulæste",
      alerts: "Advarsler",
      payments: "Betalinger",
      updates: "Opdateringer",
    },
    empty: {
      title: "Ingen notifikationer",
      unread: "Du er helt ajour! Ingen ulæste notifikationer.",
      category: "Du har endnu ingen notifikationer i denne kategori.",
    },
    actions: {
      mark_read: "Markér som læst",
      delete: "Slet",
    },
    items: {
      item_1: {
        title: "Budgetadvarsel",
        message: "Marketingbudgettet blev overskredet med 15 %. Nuværende forbrug: €11.500 / €10.000",
        time: "for 5 minutter siden",
      },
      item_2: {
        title: "Betaling modtaget",
        message: "Kunde ABC betalte faktura #INV-2024-001 på €2.500",
        time: "for 1 time siden",
      },
      item_3: {
        title: "Pengestrømsopdatering",
        message: "Din månedlige pengestrømsrapport for december 2024 er klar",
        time: "for 3 timer siden",
      },
      item_4: {
        title: "Bank tilsluttet",
        message: "Santander-konto synkroniseret. 127 nye transaktioner importeret",
        time: "for 1 dag siden",
      },
      item_5: {
        title: "Advarsel om lav saldo",
        message: "Saldoen på din driftskonto er under €5.000. Nuværende saldo: €4.250",
        time: "for 1 dag siden",
      },
      item_6: {
        title: "Betaling afventer",
        message: "Faktura #INV-2024-002 til leverandør XYZ (€1.200) forfalder om 3 dage",
        time: "for 2 dage siden",
      },
      item_7: {
        title: "Betaling sendt",
        message: "Lønudbetaling på €35.000 behandlet til 5 teammedlemmer",
        time: "for 3 dage siden",
      },
      item_8: {
        title: "Rapport genereret",
        message: "Finansiel rapport for Q4 2024 er klar. Se detaljerede indsigter og trends",
        time: "for 5 dage siden",
      },
      item_9: {
        title: "Usædvanlig transaktion",
        message: "Stor transaktion registreret: €8.500 til ukendt leverandør. Gennemgang kræves",
        time: "for 1 uge siden",
      },
      item_10: {
        title: "Tilbagevendende betaling",
        message: "Månedligt Figma-abonnement fornyet: €45",
        time: "for 1 uge siden",
      },
    },
  },
  fi: {
    title: "Ilmoitukset",
    subtitle: "Pysy ajan tasalla taloudellisista tapahtumistasi",
    mark_all_read: "Merkitse kaikki luetuiksi",
    tabs: {
      all: "Kaikki",
      unread: "Lukemattomat",
      alerts: "Hälytykset",
      payments: "Maksut",
      updates: "Päivitykset",
    },
    empty: {
      title: "Ei ilmoituksia",
      unread: "Olet ajan tasalla! Ei lukemattomia ilmoituksia.",
      category: "Tässä kategoriassa ei ole vielä ilmoituksia.",
    },
    actions: {
      mark_read: "Merkitse luetuksi",
      delete: "Poista",
    },
    items: {
      item_1: {
        title: "Budjettihälytys",
        message: "Markkinointibudjetti ylitti 15 %. Nykyiset kulut: €11.500 / €10.000",
        time: "5 minuuttia sitten",
      },
      item_2: {
        title: "Maksu vastaanotettu",
        message: "Asiakas ABC maksoi laskun #INV-2024-001 summalla €2.500",
        time: "1 tunti sitten",
      },
      item_3: {
        title: "Kassavirran päivitys",
        message: "Joulukuun 2024 kuukausittainen kassavirran raportti on valmis",
        time: "3 tuntia sitten",
      },
      item_4: {
        title: "Pankki yhdistetty",
        message: "Santander-tili synkronoitu onnistuneesti. 127 uutta tapahtumaa tuotu",
        time: "1 päivä sitten",
      },
      item_5: {
        title: "Varoitus matalasta saldosta",
        message: "Käyttötilin saldo on alle €5.000. Nykyinen saldo: €4.250",
        time: "1 päivä sitten",
      },
      item_6: {
        title: "Maksu odottaa",
        message: "Lasku #INV-2024-002 toimittajalle XYZ (€1.200) erääntyy 3 päivän kuluttua",
        time: "2 päivää sitten",
      },
      item_7: {
        title: "Maksu lähetetty",
        message: "Palkkojen maksu €35.000 käsitelty onnistuneesti 5 tiimin jäsenelle",
        time: "3 päivää sitten",
      },
      item_8: {
        title: "Raportti luotu",
        message: "Q4 2024 -talousraportti on valmis. Katso yksityiskohtaiset havainnot ja trendit",
        time: "5 päivää sitten",
      },
      item_9: {
        title: "Epätavallinen tapahtuma",
        message: "Suuri tapahtuma havaittu: €8.500 tuntemattomalle toimittajalle. Tarkistus vaaditaan",
        time: "1 viikko sitten",
      },
      item_10: {
        title: "Toistuva maksu",
        message: "Kuukausittainen Figma-tilaus uusittu: €45",
        time: "1 viikko sitten",
      },
    },
  },
};
